import React, {ReactNode, createContext, useMemo} from "react";

import {DishDetailsItem} from "@apps/dish/interfaces";

import {MenuType} from "@components/Menu/interfaces";

import {DishDetailsConfig} from "./interfaces";

const defaultConfig: DishDetailsConfig = {
  hideRating: false,
  hidePrice: false,
  showFavorites: false,
  showFavoriteHoverBox: false,
  showReviews: false,
  menuType: MenuType.Individual,
  showFullIngredientList: false,
  hidePurchaseButton: false,
  purchaseConfirmationModal: undefined,
  selectedDate: undefined,
  forceTwoColumns: false,
  showQuantityInput: false,
  isPriceShown: () => false,
  orderItems: [],
  changeItemQty: () => Promise.resolve(),
  preSelectedItem: {},
  hidePriceInDishDetails: false,
  showPriceInPurchaseButton: false,
  hasDateSelector: false,
};

export const DishDetailsConfigContext =
  createContext<DishDetailsConfig>(defaultConfig);

type DishDetailsConfigProviderProps = Partial<DishDetailsConfig> & {
  children: ReactNode;
};

export function DishDetailsConfigProvider({
  children,
  ...newConfig
}: DishDetailsConfigProviderProps): JSX.Element {
  const config: DishDetailsConfig = useMemo(() => {
    return {
      ...defaultConfig,
      ...newConfig,
    };
  }, [newConfig]);

  const isPriceShown = (item: DishDetailsItem) => {
    return Boolean(
      item.price && !config.hidePrice && Number(item.price) > 0 && !item.soldout
    );
  };

  const enrichedConfig: DishDetailsConfig = useMemo(() => {
    return {
      ...config,
      isPriceShown,
    };
  }, [config]);

  return (
    <DishDetailsConfigContext.Provider value={enrichedConfig}>
      {children}
    </DishDetailsConfigContext.Provider>
  );
}
